const GET_AZURE_CDN = "GET_AZURE_CDN";
const GET_AZURE_CDN_SUCCESS = "GET_AZURE_CDN_SUCCESS";
const GET_AZURE_CDN_ERROR = "GET_AZURE_CDN_ERROR";

export { GET_AZURE_CDN, GET_AZURE_CDN_SUCCESS, GET_AZURE_CDN_ERROR };
